import axios from "axios";

export default async function syncProfileDetails(headers) {
  try {
    const response = await axios({
      method: "get",
      url: `https://onboardstaging.backendprod.com/api/org/whatsapp/settings`,
      headers: headers,
      params: {
        sync: 1,
      },
    });

    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(error);
  }
}
